import { config, authHeader, handleResponse } from '../helpers'

export const adminService = {
   collegeStatus,
   individualCollegeParticipation,
   getReviewerData,
   getRegionalData
}

function collegeStatus() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/admin/status`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function individualCollegeParticipation(collegeId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    console.log(collegeId)
    return fetch(`${config.baseUrl}/admin/individual/${collegeId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function getReviewerData(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
}

return fetch(`${config.baseUrl}/admin/reviewers-dtls/`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getRegionalData(params){
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
  }

  return fetch(`${config.baseUrl}/admin/regionwise-data/?${params}`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data
      })
  }

